export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOAD_PROFILE = "LOAD_PROFILE";
export const LOGOUT = "LOGOUT";

export const FEED_REQUEST = "FEED_REQUEST";
export const FEED_SUCCESS = "FEED_SUCCESS";
export const FEED_ERROR = "FEED_ERROR";

export const ADD_POST_SUCCESS = "ADD_FEED_POST";
export const ADD_POST_REQ = "ADD_POST_REQ";
export const ADD_POST_ERROR = "ADD_POST_ERROR";

export const ADD_LIKE = "ADD_LIKE";
export const DISLIKE = "DISLIKE";
export const LIKE_REQ = "LIKE_REQ";
export const LIKE_ERROR = "LIKE_ERROR";

export const ADD_COMMENT = "ADD_COMMENT";
export const ADD_COMMENT_REQ = "ADD_COMMENT_REQ";
export const ADD_COMMENT_ERROR = "ADD_COMMENT_ERROR";

export const TRENDIND_REQ = "TRENDIND_REQ";
export const TRENDING_SUCCESS = "TRENDING_SUCCESS";
export const TRENDING_FAIL = "TRENDING_FAIL";

export const CURRENTUSER_SUCCESS = "CURRENTUSER_SUCCESS";
export const CURRENTUSER_FAIL = "CURRENTUSER_FAIL";
export const CURRENTUSER_REQ = "CURRENTUSER_REQ";
export const FOLLOW_CURRENT = "FOLLOW_CURRENT";
export const UNFOLLOW_CURRENT = "UNFOLLOW_CURRENT";

export const CURRENT_TWEET_SUC = "CURRENT_TWEET_SUC";
export const CURRENT_TWEET_FAIL = "CURRENT_TWEET_FAIL";
export const CURRENT_TWEET_REQ = "CURRENT_TWEET_REQ";
export const ADD_COMMENT_CURRENT_TWEET_SUC = "ADD_COMMENT_CURRENT_TWEET_SUC";
export const ADD_COMMENT_CURRENT_TWEET_REQ = "ADD_COMMENT_CURRENT_TWEET_REQ";
export const LIKE_CURRENT_TWEET = "LIKE_CURRENT_TWEET";
export const DISLIKE_CURRENT_TWEET = "DISLIKE_CURRENT_TWEET";

export const CURRENT_USER_TWEET_REQ = "CURRENT_USER_TWEET_REQ";
export const CURRENT_USER_TWEET_FAIL = "CURRENT_USER_TWEET_FAIL";
export const CURRENT_USER_TWEET_SUCCESS = "CURRENT_USER_TWEET_SUCCESS";

export const USER_LIKED_TWEET_SUCC = "USER_LIKED_TWEET_SUCC";
export const USER_LIKED_REQ = "USER_LIKED_REQ";
export const USER_LIKED_ERR = "USER_LIKED_ERR";
export const LIKE_LIKED_TWEET = "LIKE_LIKED_TWEET";
export const DISLIKE_LIKED_TWEET = "DISLIKE_LIKED_TWEET";
export const ADD_COMMENT_LIKED_TWEET = "ADD_COMMENT_LIKED_TWEET";
export const ADD_COMMENT_LIKED_TWEET_REQ = "ADD_COMMENT_LIKED_TWEET_REQ";

export const GET_FOLLOWERS = "GET_FOLLOWERS";
export const GET_FOLLOWING = "GET_FOLLOWING";
export const GET_FOLLOWING_REQ = "GET_FOLLOWING_REQ";

export const MY_TWEETS_SUC = "MY_TWEETS_SUC";
export const MY_TWEETS_FAIL = "MY_TWEETS_FAIL";
export const MY_TWEETS_REQ = "MY_TWEETS_REQ";

export const EDIT_TWEET_SUCCCESS = "EDIT_TWEET_SUCCESS";
export const EDIT_TWEET_FAIL = "EDIT_TWEET_FAIL";

export const DELETE_TWEET_SUCCESS = "DELETE_TWEET_SUCCESS";
export const DELETE_TWEET_FAIL = "DELETE_TWEET_FAIL";

export const EDIT_PROFILE_REQ = "EDIT_PROFILE_REQ";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";
export const EDIT_PROFILE_FAIL = "EDIT_PROFILE_FAIL";

export const UPDATE_MY_FOLLOWING_Y = "UPDATE_MY_FOLLOWING_Y";
export const UPDATE_MY_FOLLOWING_N = "UPDATE_MY_FOLLOWING_N";
